// extracted by mini-css-extract-plugin
export var dataCell = "_hj-2";
export var dataRow = "_hj-0";
export var headerRow = "_hj-1";